module.exports = __webpack_public_path__ + "img/company_cover.7a0844f6.png";